exports.getAndroidVersion = () => {
  var v_info = navigator.userAgent.match(/android [\d._]+/gi);
  var version = (v_info + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");
  return version;
}

exports.getAndroidMajorVersion = () => {
  var version = this.getAndroidVersion();
  version = parseInt(version.split('.')[0]); // 得到版本号第一位
  return version;
}

exports.getIOSVersion = () => {
  var v_info = navigator.userAgent.match(/os [\d._]+/gi);
  var version = (v_info + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");  // 得到版本号9.3.2或者9.0
  return version;
}

function isWechat () {
  var ua = navigator.userAgent.toLowerCase()
  if(ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

exports.getWechat = () => {
  if (!isWechat()) return undefined;
  return {
    getVersion: ()=> {
      var version;
      var wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i) ;
      if (wechat) {
        version = wechat[1]
      }
      return version
    },
    isVersionGreater: (major, minor, fix) => {
      var isGreater = false; 
      major = major || 7;
      minor = minor || 0;
      fix = fix || 12;
      var version = this.getWechatVersion();
      if (version) {
        var vinfo = version.split('.')
        vinfo[0] = parseInt(vinfo[0])
        vinfo[1] = parseInt(vinfo[1])
        vinfo[2] = parseInt(vinfo[2])
        if(vinfo[0] >= major) {
          if(vinfo[0] > major) {
            isGreater = true;
          } else {
            if(vinfo[1] >= minor) {
              if(vinfo[1] > minor) {
                isGreater = true;
              } else {
                if(vinfo[2] >= fix) {
                  isGreater = true;
                }
              }
            }
          }
        } 
      }
      return isGreater;
    }
  }
}